
import * as L from "leaflet";
import Marker from '@assets/icons/marker-icon-2x.png'
import FieldMarker from '@assets/icons/marker-icon.png'
import waterMarker from '@assets/icons/water.png'

export const CustomMarker = L.icon({
  iconSize: [36, 62],
  shadowSize: [20, 37],
  iconAnchor: [18, 56],
  iconUrl: Marker,
});

export const FieldMarkerIcon = L.icon({
  iconSize: [36, 62],
  shadowSize: [20, 37],
  iconAnchor: [18, 56],
  iconUrl: FieldMarker,
})

export const waterMarkerIcon = L.icon({
  iconSize: [36, 62],
  shadowSize: [20, 37],
  iconAnchor: [18, 56],
  iconUrl: waterMarker,
})

export const samplingStationIcon = (serviceReport, i) => {
  if (serviceReport === 'EXPERIMENT') {
    return new L.DivIcon({
      className: 'customDivIconLabelSoil',
      iconSize: [20, 20],
      iconAnchor: [10, 10],
      popupAnchor: [10, 10],
      html: `<div><span>${i + 1}</span></div>`
    })
  }
  if (serviceReport === 'VISIT') {
    return new L.DivIcon({
      className: 'customDivIconLabelVisit',
      iconSize: [5, 5],
      iconAnchor: [10, 10],
      popupAnchor: [10, 10],
    })
  }
} 